<template>
  <div>
    <div class="container fr-aic fr-jcsb">
      <comp-tab :data="[{ label: '全部营销规则', value: 2 }, { label: '已删除', value: 1 }]" v-model="params.isdeleted" />
      <el-button @click="$router.push({ name: 'marketing-edit' })" size="small" type="primary">新建营销规则</el-button>
    </div>
    <div class="container">
      <el-row gutter="8">
        <el-col span="4">
          <el-input placeholder="输入营销规则ID搜索" prefix-icon="el-icon-search" size="small" v-model="params.id"></el-input>
        </el-col>
        <el-col span="4">
          <el-button @click="onSearch" size="small">搜索</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="container">
      <el-table :data="list" border style="width: 100%">
        <el-table-column align="center" label="ID" prop="id" width="50" />
        <el-table-column label="营销规则名称" prop="name" />
        <el-table-column label="规则类型">
          <template slot-scope="{ row }">
            <div v-if="row.kind === 0">用户手动领券</div>
            <div v-if="row.kind === 1">订单满减</div>
            <div v-if="row.kind === 2">订单满赠</div>
          </template>
        </el-table-column>
        <el-table-column label="适用范围">
          <template slot-scope="{ row }">
            <span v-if="row.kind !== 0 && row.producttype == 0">作用于所有商品</span>
            <span v-if="row.kind !== 0 && row.producttype == 1">作用于部分商品</span>
            <span v-if="row.kind !== 0 && row.producttype == 2">不作用于部分商品</span>
            <span v-if="row.kind === 0 && row.newuser === 0 && row.producttype == 0">展示在所有商品</span>
            <span v-if="row.kind === 0 && row.newuser === 0 && row.producttype == 1">展示在部分商品</span>
            <span v-if="row.kind === 0 && row.newuser === 0 && row.producttype == 2">不展示在部分商品</span>
            <span v-if="row.kind === 0 && row.newuser === 1">仅限新用户领取</span>
          </template>
        </el-table-column>
        <el-table-column label="赠品">
          <template slot-scope="{ row }">
            <div @click="$router.push({ name: 'marketing-coupon-template-detail', query: { id: row.coupontemplate.id } })" class="marketing-link" v-if="row.coupontemplate">(券){{ row.coupontemplate.name }}</div>
            <div @click="onClickProduct(row.product)" class="marketing-link" v-if="row.product">(商品){{ row.product.name }}</div>
          </template>
        </el-table-column>
        <el-table-column label="有效期">
          <template slot-scope="{ row }">
            <div v-if="row.begintime > 0 || row.endtime > 0">{{ new Date(row.begintime * 1000).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' }) }} - {{ new Date(row.endtime * 1000).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' }) }}</div>
            <div v-if="row.begintime == 0 && row.endtime == 0">不限制</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="150">
          <template slot-scope="scope">
            <el-button @click="$router.push({ name: 'marketing-detail', query: { id: scope.row.id } })" size="small" type="text">明细</el-button>
            <el-button @click="onClickDel(scope.row)" size="small" type="text" v-if="!scope.row.deletedat">删除</el-button>
            <el-button @click="onClickCopy(scope.row)" size="small" type="text" v-if="scope.row.deletedat">复制</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-bottom">
        <el-button v-if="hasMore" :loading="loadmore" @click="getMarketings" size="small" type="primary">加载更多</el-button>
        <span v-else style="color: #ccc; font-size: 12px;">已经加载全部，没有更多了</span>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Tab from '../../../components/tab/index.vue';
import { M } from '../../../service/grpc.js';
import { rpc } from '../../../service/index.js';
import { getToken } from '../../../service/helper.js';

export default {
  components: {
    'comp-tab': Tab
  },
  data() {
    return {
      params: {
        id: '',
        kind: -1,
        isdeleted: 2,
        idlessthan: 0,
        count: 20
      },
      list: [],
      loadmore: false,
      hasMore: true,
      token: ''
    };
  },
  created() {
    this.token = getToken();
    this.getMarketings();
  },
  watch: {
    'params.isdeleted': function() {
      this.list = [];
      this.getMarketings();
    }
  },
  methods: {
    async getMarketings() {
      this.loadmore = true;
      const { scrollY } = window;
      this.params.idlessthan = this.list.length ? this.list[this.list.length - 1].id : 0;
      const res = await rpc(
        'StoreMarketingService.GetMarketingList',
        M('MarketingListQueryRequest', {
          token: M('Token', { token: this.token }),
          ...this.params
        })
      );
      const coupontemplateidlist = [];
      const productidlist = [];
      res.marketinglistList.map(item => {
        if (item.kind === 0) coupontemplateidlist.push(item.giftid);
        if (item.kind === 2 && item.gifttype === 0) coupontemplateidlist.push(item.giftid);
        if (item.kind === 2 && item.gifttype === 1) productidlist.push(item.giftid);
      });
      const reslist = await Promise.all([
        coupontemplateidlist.length
          ? rpc(
              'StoreCouponTemplateService.GetCouponTemplateList',
              M('CouponTemplateListQueryRequest', {
                token: M('Token', { token: this.token }),
                idlistList: coupontemplateidlist,
                count: coupontemplateidlist.length
              })
            )
          : null,
        productidlist.length
          ? rpc(
              'StoreProductService.GetProductList',
              M('ProductListQueryRequest', {
                token: M('Token', { token: this.token }),
                idlistList: productidlist,
                count: productidlist.length,
                sortby: 1,
                sort: 1
              })
            )
          : null
      ]);

      res.marketinglistList.forEach(item => {
        item.coupontemplate = null;
        item.product = null;
        if (item.kind === 0) {
          item.coupontemplate = reslist[0].coupontemplatelistList.find(v => v.id === item.giftid);
        }
        if (item.kind === 2 && item.gifttype === 0) {
          item.coupontemplate = reslist[0].coupontemplatelistList.find(v => v.id === item.giftid);
        }
        if (item.kind === 2 && item.gifttype === 1) {
          item.product = reslist[1].productlistList.find(v => v.id === item.giftid);
        }
      });
      this.list = this.list.concat(res.marketinglistList);
      this.hasMore = res.marketinglistList.length;
      if (this.params.idlessthan !== 0) {
        window.scroll(0, scrollY);
      }
      this.loadmore = false;
    },

    onClickDel(row) {
      row = JSON.parse(JSON.stringify(row));
      row.deletedat = parseInt(Date.now() / 1000);
      rpc(
        'StoreMarketingService.UpdateMarketing',
        M('MarketingWithTokenRequest', {
          token: M('Token', { token: this.token }),
          marketing: M('Marketing', row)
        })
      ).then(res => {
        this.list.splice(this.list.findIndex(v => v.id === res.id), 1, res);
        this.$message({
          message: '操作成功',
          type: 'success'
        });
      });
    },

    onClickProduct(product) {
      this.$router.push({ name: 'products-edit', query: { id: product.id, type: 'edit' } });
    },

    async onClickCopy(row) {
      row = JSON.parse(JSON.stringify(row));
      row.deletedat = 0;
      const res = await rpc(
        'StoreMarketingService.CreateMarketing',
        M('MarketingWithTokenRequest', {
          token: M('Token', { token: this.token }),
          marketing: M('Marketing', row)
        })
      );
      res.coupontemplate = null;
      res.product = null;
      if (res.kind === 2 && res.gifttype === 0) {
        res.coupontemplate = await rpc(
          'StoreCouponTemplateService.GetCouponTemplate',
          M('IDWithTokenRequest', {
            token: M('Token', { token: this.token }),
            id: res.giftid
          })
        );
      }
      if (res.kind === 2 && res.gifttype === 1) {
        res.product = await rpc(
          'StoreProductService.GetProduct',
          M('IDWithTokenRequest', {
            token: M('Token', { token: this.token }),
            id: res.giftid
          })
        );
      }
      this.list.splice(0, 0, res);
      this.$message({
        message: '操作成功',
        type: 'success'
      });
    },

    onSearch() {
      this.list = [];
      this.getMarketings();
    }
  }
};
</script>

<style>
.marketing-link {
  color: rgb(97, 179, 211);
  cursor: pointer;
}
</style>
